import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { WideLayout } from '../../../../shared/layout/widelayout';
import { OrderFlowPageHeader } from '../../../../shared/ui/orderFlowPageHeader';
import { usePortalStore } from '../../../../stores/portalStore';
import { useOrderFlowStore } from '../../store/newOrderFlowStore';
import { TilesSelection } from '../../components/new-order/tilesSelection';
/**
 *
 * @returns
 */
export const OrderSelectCategory = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const currentUser = usePortalStore((state) => state.currentUser);
  const setSelectedCategory = useOrderFlowStore(
    (state) => state.setSelectedCategory
  );
  const availableCategories = useOrderFlowStore(
    (state) => state.availableCategories
  );
  const selectedArea = useOrderFlowStore((state) => state.selectedArea);
  const selectedPatient = useOrderFlowStore((state) => state.selectedPatient);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !selectedArea ||
      !Array.isArray(availableCategories) ||
      availableCategories.length === 0
    ) {
      navigate('/order/selectPatient');
    }
  }, [selectedArea, availableCategories, navigate]);

  const onClickCategory = async (category) => {
    await setSelectedCategory(currentUser.cnpj, { ...category });
    navigate(
      `/order/selectSubCategory?category=${category['title']}&categoryId=${category['id']}`
    );
  };

  const mergeCategories = () => {
    const areaCategories = selectedArea?.categories ?? [];
    return availableCategories
      .filter(Boolean)
      .filter((category) => {
        const categoryText = `${category.title ?? ''} ${
          category.description ?? ''
        }`.toLowerCase();
        return (
          !categoryText.includes('descartáveis para equipamentos médicos') &&
          !categoryText.includes(
            'dispositivos e acessórios de equipamentos médicos'
          )
        );
      })
      .map((category) => {
        const match = areaCategories.find(
          (item) => item.id === category.description
        );
        const title = match?.title ?? category.title ?? category.description;
        return {
          ...category,
          title,
          coverImageURL: category.coverImageURL ?? match?.coverImageURL,
          shortDescription:
            category.shortDescription ?? match?.shortDescription ?? '',
        };
      });
  };

  return (
    <WideLayout
      outlet={
        <>
          <div style={{ padding: '20px 24px 0' }}>
            <OrderFlowPageHeader
              title="Implantação"
              subtitle={`Solicite a implantação de equipamentos para ${
                selectedPatient?.name ?? 'o paciente'
              }.`}
            />
          </div>
          <TilesSelection
            onClickTile={onClickCategory}
            tiles={mergeCategories()}
          ></TilesSelection>
        </>
      }
    ></WideLayout>
  );
};
